import { TileExtension, ITileGlobalExtensionContext, Tile, TileGroups,
  TileEvaluationEventArgs , ITileLocalExtensionContext,
  disableWithCollapsing} from 'tessa/ui/tiles';
import { tryGetFromInfo, UIContext, showError, showNotEmpty, showConfirmWithCancel, LoadingOverlay, showMessage, IUIContext, showConfirm, showLoadingOverlay} from 'tessa/ui';
import { IStorage } from 'tessa/platform/storage';
import { createTypedField, DotNetType, TypedField } from 'tessa/platform';
import { CardStoreMode } from 'tessa/cards';
import { createCard } from 'tessa/ui/uiHost';
import { CardService, CardRequest, CardGetFileContentRequest } from 'tessa/cards/service';
import { KrToken } from 'tessa/workflow';
import { userSession } from 'common/utility';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { CdCardFlagsInfo } from '../Helpers/CdCardFlagsInfo';
import { CdProcessHelper } from '../Helpers/CdProcessHelper';
import { CdRequestTypes } from '../Helpers/CdRequestTypes';
import { CdCardHelper } from '../Helpers/CdCardHelper';
import { CdTechnicalDocumentationClientHelper } from '../Helpers/Cards/CdTechnicalDocumentationClientHelper';
import moment from 'moment';
import { CdFileTypes } from '../Helpers/CdFileTypes';
import { PkCommonHelper } from 'src/pkScripts/Helpers/PkCommonHelper';
import { ITessaView, Paging, TessaViewRequest, ViewPagingParameters } from 'tessa/views';
import { IViewParameters } from 'tessa/ui/views/parameters';
import { ViewReferenceMetadataSealed } from 'tessa/views/metadata';
import { PkMatrixWorkplaceHelper } from 'src/pkScripts/Views/PkMatrixWorkplaceHelper';
import { CdStaticRoles } from '../Helpers/CdStaticRoles';

export class CdCardTileExtension extends TileExtension {

  public initializingGlobal(context: ITileGlobalExtensionContext) {
    const panel = context.workspace.leftPanel;

    panel.tiles.push(new Tile({
      name: "CreateBasedOn",
      caption: "Создать изменение\nили дополнение",
      icon: "ta icon-thin-077",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 20,
      command: CdCardTileExtensionHelper.copyBasedOnAction,
      evaluating: CdCardTileExtensionHelper.canCreateBasedDocumentAction
    }));
    let actionTile = new Tile({
      name: "CdActions",
      caption: "Действия",
      icon: "ta icon-thin-258",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 25,
      command: null,
      evaluating: CdCardTileExtensionHelper.enableActionTile
    });
    panel.tiles.push(actionTile);
    actionTile.tiles.push(new Tile({
      name: "AddToFavorites",
      caption: "Добавить\nв Избранное",
      icon: "ta icon-thin-231",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 40,
      command: CdCardTileExtensionHelper.addToFavorites,
      evaluating: CdCardTileExtensionHelper.canAddToFavorites
    }));
    actionTile.tiles.push(new Tile({
      name: "AddToFavorites",
      caption: "Убрать\nиз Избранного",
      icon: "ta icon-thin-252",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 50,
      command: CdCardTileExtensionHelper.removeFromFavorites,
      evaluating: CdCardTileExtensionHelper.canRemoveFromFavorites
    }));
    actionTile.tiles.push(new Tile({
      name: "CopyCard",
      caption: "Скопировать карточку",
      icon: "ta icon-thin-050",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 60,
      command: CdCardTileExtensionHelper.copyCardAction,
      evaluating: CdCardTileExtensionHelper.canCopyCard
    }));
    actionTile.tiles.push(new Tile({
      name: "CopyARFOWithChangeKc",
      caption: "Создание дубля карточки\nпри обновлении версии Расчета КЦ\n(с архивацией предыдущей карточки)",
      icon: "ta icon-thin-050",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 60,
      command: CdCardTileExtensionHelper.copyARFOWithChangeKc,
      evaluating: CdCardTileExtensionHelper.canCopyARFO
    }));
    actionTile.tiles.push(new Tile({
      name: "CopyARFOWithoutChangeKc",
      caption: "Создание дубля карточки для исправления ошибок\nбез изменения версии Расчета КЦ\n(с архивацией предыдущей карточки)",
      icon: "ta icon-thin-050",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 60,
      command: CdCardTileExtensionHelper.copyARFOWithoutChangeKc,
      evaluating: CdCardTileExtensionHelper.canCopyARFO
    }));
    // actionTile.tiles.push(new Tile({
    //   name: "CdDownloadCSVReport",
    //   caption: "Выгрузить сравнение РНС и РВЭ",
    //   icon: "ta icon-thin-085",
    //   contextSource: panel.contextSource,
    //   group: TileGroups.Cards,
    //   order: 70,
    //   command: CdCardTileExtensionHelper.downloadCSVReport,
    //   evaluating: CdCardTileExtensionHelper.canDownloadCSVReport
    // }));

    panel.tiles.push(new Tile({
      name: "PkUnolockCards",
      caption: "Разблокировать\nвыбранные карточки",
      icon: "ta icon-thin-064",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 60,
      command: CdCardTileExtensionHelper.unlockCards,
      evaluating: CdCardTileExtensionHelper.canUnlockCards
    }));

    panel.tiles.push(new Tile({
      name: "PkRegisterCards",
      caption: "Зарегистрировать\nвыбранные карточки",
      icon: "ta icon-thin-091",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 60,
      command: CdCardTileExtensionHelper.registerCards,
      evaluating: CdCardTileExtensionHelper.canRegisterCards
    }));

    panel.tiles.push(new Tile({
      name: "CdDownloadEDRegistry",
      caption: "Выгрузить реестр ИД",
      icon: "ta icon-thin-079",
      contextSource: panel.contextSource,
      group: TileGroups.Cards,
      order: 91,
      command: CdCardTileExtensionHelper.downloadEDRegistryAction,
      evaluating: CdCardTileExtensionHelper.canDownloadEDRegistry
    }));


  }

  public initializingLocal(context: ITileLocalExtensionContext) {
    const panel = context.workspace.leftPanel;
    const editor = panel.context.cardEditor;
    let typeid;
    if (editor == null || editor.cardModel == null ||
      editor.cardModel.cardType.id == null) {
      return;
    }
    typeid = editor.cardModel.cardType.id;
    if (typeid === CdCardTypes.PkKCKPartnerTypeID) {
      let createCardCopy = panel.tryGetTile('CreateCardCopy');
      if (createCardCopy != null) {
        disableWithCollapsing(createCardCopy);
      }
      let copyCardLink = panel.tryGetTile('CopyCardLink');
      if (copyCardLink != null) {
        disableWithCollapsing(copyCardLink);
      }
      let createCardTemplate = panel.tryGetTile('CreateCardTemplate');
      if (createCardTemplate != null) {
        disableWithCollapsing(createCardTemplate);
      }
      let celeteCard = panel.tryGetTile('DeleteCard');
      if (celeteCard != null) {
        disableWithCollapsing(celeteCard);
      }
      if (tryGetFromInfo(editor.cardModel.card.info, CdCardFlagsInfo.PkCanSavePartnersKckCard, false)) {
        let saveCard = panel.tryGetTile('SaveCard');
        if (saveCard != null) {
          disableWithCollapsing(saveCard);
        }
      }
    }

    if (typeid === CdCardTypes.PkAdditionalWorksContractOrderTypeID) {
      CdCardTileExtensionHelper.CheckDostroyUser();
    }
  }
}

export class CdCardTileExtensionHelper {

  private static isWorkingDocumentation(card: any) {
    let techDocTileVis = false;
    let section;
    let filed;
    if ((section = card.sections.tryGet('PkDocumentCommonInfo')) != null) {
      if (section.fields.tryGet("StageID") != null) {
        if ((filed = section.fields.tryGet("StageID")) != null) {
          if (filed === 2) {
            techDocTileVis = true;
          }
        }
      }
    }
    return techDocTileVis;
  }

  public static canCreateBasedDocumentAction(e: TileEvaluationEventArgs) {
    const editor = e.currentTile.context.cardEditor;
    let model;
    let card;

    e.setIsEnabledWithCollapsing(
      e.currentTile,
      editor != null && (model = editor.cardModel) != null && (card = model.card) != null &&
      card.storeMode === CardStoreMode.Update &&
      model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID &&
      tryGetFromInfo(model.card.info, "CanCreateBasedDocumentAction", false) &&
      CdCardTileExtensionHelper.isWorkingDocumentation(card) &&
      !CdTechnicalDocumentationClientHelper.CheckIsInvestment(card));
  }

  public static canUnlockCards(e:TileEvaluationEventArgs)
 {    
   const viewContext = UIContext.current.viewContext;
   if (!viewContext
     || !viewContext.view
     || !viewContext.view.metadata 
     || viewContext.view.metadata.alias !== 'PkLocks'
     ||  !viewContext!.selectedRows
   ) {
     
     e.setIsEnabledWithCollapsing(
       e.currentTile, false);
     return;
   }

     let context = e.currentTile.context;
     let cards = context!.viewContext!.selectedRows!.map(x => createTypedField(x.get("CardID"), DotNetType.Guid));
     e.setIsEnabledWithCollapsing(
         e.currentTile,
         cards.length > 0);
 }

  public static canRegisterCards(e: TileEvaluationEventArgs) {
    const viewContext = UIContext.current.viewContext;
    if (!viewContext
      || !viewContext.view
      || !viewContext.view.metadata
      || (viewContext.view.metadata.alias != 'PkIncomingDocuments'
        && viewContext.view.metadata.alias != 'PkOutgoingDocuments'
        && viewContext.view.metadata.alias != 'PkTechnicalDocumentation'
        && viewContext.view.metadata.alias != 'PkAllCard'
      )
      || !viewContext!.selectedRows
      || !userSession.isAdmin

    ) {
      e.setIsEnabledWithCollapsing(
        e.currentTile, false);
      return;
    }

    let context = e.currentTile.context;
    let cards = context!.viewContext!.selectedRows!.map(x => createTypedField(x.get("DocID") || x.get("CardID"), DotNetType.Guid));
    e.setIsEnabledWithCollapsing(
      e.currentTile,
      cards.length > 0);
  }

  public static enableActionTile(e: TileEvaluationEventArgs) {
    const editor = e.currentTile.context.cardEditor;
    let model;
    let card;

    e.setIsEnabledWithCollapsing(
      e.currentTile,
      editor != null && (model = editor.cardModel) != null && (card = model.card) != null &&
      CdCardHelper.CanEnableActionTile(model, card)
    );
  }

  public static canStartExecutionProcess(e: TileEvaluationEventArgs) {
    const editor = e.currentTile.context.cardEditor;
    let model;
    let card;

    e.setIsEnabledWithCollapsing(
      e.currentTile,
      editor != null && (model = editor.cardModel) != null && (card = model.card) != null &&
      card.storeMode === CardStoreMode.Update &&
      (model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID &&
        tryGetFromInfo(model.card.info, "CanStartExecutionProcess", false) ||
        CdCardTypes.TileExecutionAcquaintanceCardTypes.indexOf(model.cardType.id) > -1));
  }

  public static canStartAcquaintanceProcess(e: TileEvaluationEventArgs) {
    const editor = e.currentTile.context.cardEditor;
    let model;
    let card;

    e.setIsEnabledWithCollapsing(
      e.currentTile,
      editor != null && (model = editor.cardModel) != null && (card = model.card) != null &&
      card.storeMode === CardStoreMode.Update &&
      (model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID &&
        tryGetFromInfo(model.card.info, "CardStartAcquaintanceProcess", false) ||
        CdCardTypes.TileExecutionAcquaintanceCardTypes.indexOf(model.cardType.id) > -1));
  }

  public static canAddToFavorites(e: TileEvaluationEventArgs) {
    const editor = e.currentTile.context.cardEditor;
    let model;
    let card;

    e.setIsEnabledWithCollapsing(
      e.currentTile,
      editor != null && (model = editor.cardModel) != null && (card = model.card) != null &&
      card.storeMode === CardStoreMode.Update &&
      model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID &&
      tryGetFromInfo(model.card.info, "CanAddToFavorites", false) &&
      !tryGetFromInfo(model.card.info, "DocumentIsInFavorites", false));
  }

  public static canRemoveFromFavorites(e: TileEvaluationEventArgs) {
    const editor = e.currentTile.context.cardEditor;
    let model;
    let card;

    e.setIsEnabledWithCollapsing(
      e.currentTile,
      editor != null && (model = editor.cardModel) != null && (card = model.card) != null &&
      card.storeMode === CardStoreMode.Update &&
      model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID &&
      tryGetFromInfo(model.card.info, "CanAddToFavorites", false) &&
      tryGetFromInfo(model.card.info, "DocumentIsInFavorites", false));
  }

  public static canCopyCard(e: TileEvaluationEventArgs) {
    const editor = e.currentTile.context.cardEditor;
    let model;
    let card;

    e.setIsEnabledWithCollapsing(
      e.currentTile,
      editor != null && (model = editor.cardModel) != null && (card = model.card) != null &&
      card.storeMode === CardStoreMode.Update &&
      (model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID &&
        tryGetFromInfo(model.card.info, "CanCopyCard", false)
        ||
        (model.cardType.id === CdCardTypes.PkProtocolTenderTypeID || model.cardType.id === CdCardTypes.PkWorkOrderTypeID) ||
        tryGetFromInfo(model.card.info, "CanCopyChCard", false)
      )
    );
  }
  

  public static _isDostroyUser: boolean = false;
  
  static CheckDostroyUser() {
    PkMatrixWorkplaceHelper.CheckUserInRoleAsync(CdStaticRoles.УправлениеДострояИВосстановления).then((res) => {
      CdCardTileExtensionHelper._isDostroyUser = res;
    });
  
}

  public static canCopyARFO(e: TileEvaluationEventArgs) {
    const editor = e.currentTile.context.cardEditor;
    let model;
    let card;
    let visible = false;

    if (editor != null && (model = editor.cardModel) != null && (card = model.card) != null &&
      card.storeMode === CardStoreMode.Update &&
      model.cardType.id === CdCardTypes.PkAdditionalWorksContractOrderTypeID
      && card.sections.tryGet('PkDocumentCommonInfo') != null
      && card.sections.tryGet('PkDocumentCommonInfo').fields.tryGet("StateName") == "Согласовано") {

      visible = true;

      // TES-10760 Блокировать возможность создания дублей для маршруту Управления Достроя
      if ( card.sections.tryGet('PkAdditionalWorksContractOrder') != null && card.sections.tryGet('PkAdditionalWorksContractOrder').fields.tryGet("IsExploitationID") == 2) {
        visible =  CdCardTileExtensionHelper._isDostroyUser;
      }
    }
    e.setIsEnabledWithCollapsing(e.currentTile, visible);
    
    //
    CdCardTileExtensionHelper.CheckDostroyUser();
  }
 

  // public static canDownloadCSVReport(e: TileEvaluationEventArgs) {
  //   let visible = false;
  //   let viewContext = e.currentTile.context.viewContext;
  //   if (viewContext != null && viewContext.any()
  //     && viewContext.view != null && viewContext.workplace != null && viewContext.workplace.currentItem != null)
  //   {
  //       var item = viewContext.workplace.currentItem;
  //       while (item.parent != null && item.parent.parent != null)
  //       {
  //         if (item.text == "Документ ИДП")
  //         {
  //           visible = true;
  //           break;
  //         }

  //           item = item.parent;
  //       }
  //   }

  //   e.SetIsEnabledWithCollapsing(e.CurrentTile, visible);
  // }

  public static async copyBasedOnAction() {
    let uiContext = UIContext.current;
    let editor = uiContext.cardEditor;
    let model;
    if (uiContext == null || editor == null ||
      (model = editor.cardModel) == null ||
      model.card == null) {
      return;
    }

    let saveBeforeCreatingCard = false;
    if (model.hasChanges()) {
      const result = await showConfirmWithCancel("$UI_Cards_ConfirmSavingCardBeforeCreatingBasedOn");
      if (result == null) {
        return;
      }
      saveBeforeCreatingCard = result;
    }

    if (saveBeforeCreatingCard) {
      const success = await editor!.saveCard(uiContext);
      if (!success) {
        return;
      }
    }

    const baseCard = editor.cardModel!.card;
    const requestInfo: IStorage = {};
    requestInfo['KrCreateBasedOnCardID'] = createTypedField(baseCard.id, DotNetType.Guid);
    requestInfo['KrCreateBasedOnCopyFiles'] = createTypedField(false, DotNetType.Boolean);
    requestInfo['BasedOn'] = createTypedField(true, DotNetType.Boolean);

    const baseCardToken = KrToken.tryGet(baseCard.info);
    if (baseCardToken != null) {
      const tokenStorage: IStorage = {};
      baseCardToken.setInfo(tokenStorage);
      requestInfo['KrCreateBasedOnToken'] = tokenStorage;
    }

    await LoadingOverlay.instance.show(async () => {
      await createCard({
        cardTypeId: model.cardType.id,
        cardTypeName: model.cardType.name,
        info: requestInfo,
        creationModeDisplayText: '$UI_Tiles_CreateCard_Suffix_BasedOn'
      });
    });
  }

  /** Разблокировать выбранные карточки в папке поддержки для рм админ. */
  public static unlockCards() {
    let cards: TypedField[] = new Array;
    const context: IUIContext = UIContext.current;
    cards = context!.viewContext!.selectedRows!.map(x => createTypedField(x.get("CardID"), DotNetType.Guid));

    const contractRequest = new CardRequest();
    contractRequest.requestType = CdRequestTypes.UnlockCards;
    contractRequest.info["Cards"] = cards;
    CardService.instance.request(contractRequest).then(response => {
      showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
        return null;
      }
      context!.viewContext!.refreshView();
    });
  }

  /** Зарегистрировать выбранные карточки*/
  public static registerCards() {
    let cards: TypedField[] = new Array;
    const context: IUIContext = UIContext.current;
    cards = context!.viewContext!.selectedRows!.map(x => createTypedField(x.get("DocID") || x.get("CardID"), DotNetType.Guid));

    const contractRequest = new CardRequest();
    contractRequest.requestType = CdRequestTypes.RegisterCards;
    contractRequest.info["Cards"] = cards;
    CardService.instance.request(contractRequest).then(response => {
      showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
        return null;
      }
      context!.viewContext!.refreshView();
    });
  }


  public static async startExecutionProcessAction() {
    let uiContext = UIContext.current;
    let editor = uiContext.cardEditor;
    let model;
    if (uiContext == null || editor == null ||
      (model = editor.cardModel) == null ||
      model.card == null) {
      return;
    }
    const storeInfo: IStorage = {
      '.startProcess': createTypedField(CdProcessHelper.PerformanceProcessName, DotNetType.String),
      'WithInitialization': createTypedField(true, DotNetType.Boolean)
    };
    editor.saveCard(uiContext, storeInfo);
  }

  public static async startAcquaintanceProcessAction() {
    let uiContext = UIContext.current;
    let editor = uiContext.cardEditor;
    let model;
    if (uiContext == null || editor == null ||
      (model = editor.cardModel) == null ||
      model.card == null) {
      return;
    }
    const storeInfo: IStorage = {
      '.startProcess': createTypedField(CdProcessHelper.AcquaintanceProcess, DotNetType.String),
      'WithInitialization': createTypedField(true, DotNetType.Boolean)
    };
    editor.saveCard(uiContext, storeInfo);
  }

  public static async addToFavorites() {
    let uiContext = UIContext.current;
    let editor = uiContext.cardEditor;
    let model;
    const session = userSession;
    if (uiContext == null || editor == null ||
      (model = editor.cardModel) == null ||
      model.card == null) {
      return;
    }

    const request = new CardRequest();

    request.requestType = CdRequestTypes.AddDocumentToFavorites;

    request.info["DocumentID"] = createTypedField(model.card.id, DotNetType.Guid);
    request.info["UserID"] = createTypedField(session.UserID, DotNetType.Guid);

    const response = await CardService.instance.request(request);

    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
      return;
    }

    if (!tryGetFromInfo(response.info, "DocumentIsInFavorites", false)) {
      await showError("Не удалось добавить документ в Избранное");
    }
    else {
      await showMessage("Документ добавлен в Избранное");
      model.card.info["DocumentIsInFavorites"] = createTypedField(true, DotNetType.Boolean);
    }
  }

  public static async removeFromFavorites() {
    let uiContext = UIContext.current;
    let editor = uiContext.cardEditor;
    let model;
    const session = userSession;
    if (uiContext == null || editor == null ||
      (model = editor.cardModel) == null ||
      model.card == null) {
      return;
    }

    const request = new CardRequest();

    request.requestType = CdRequestTypes.RemoveDocumentFromFavorites;

    request.info["DocumentID"] = createTypedField(model.card.id, DotNetType.Guid);
    request.info["UserID"] = createTypedField(session.UserID, DotNetType.Guid);

    const response = await CardService.instance.request(request);

    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
      return;
    }

    if (tryGetFromInfo(response.info, "DocumentIsInFavorites", null) == null) {
      await showError("Не удалось удалить документ из Избранного");
    }
    else {
      await showMessage("Документ удален из Избранного");
      model.card.info["DocumentIsInFavorites"] = createTypedField(false, DotNetType.Boolean);
    }
  }

  public static async copyCardAction() {
    let uiContext = UIContext.current;
    let editor = uiContext.cardEditor;
    let model;
    if (uiContext == null || editor == null ||
      (model = editor.cardModel) == null ||
      model.card == null) {
      return;
    }

    let saveBeforeCreatingCard = false;
    if (model.hasChanges()) {
      const result = await showConfirmWithCancel("$UI_Cards_ConfirmSavingCardBeforeCreatingBasedOn");
      if (result == null) {
        return;
      }
      saveBeforeCreatingCard = result;
    }

    if (saveBeforeCreatingCard) {
      const success = await editor!.saveCard(uiContext);
      if (!success) {
        return;
      }
    }

    const baseCard = editor.cardModel!.card;
    const requestInfo: IStorage = {};
    requestInfo['KrCreateBasedOnCardID'] = createTypedField(baseCard.id, DotNetType.Guid);
    requestInfo['KrCreateBasedOnCopyFiles'] = createTypedField(false, DotNetType.Boolean);

    const baseCardToken = KrToken.tryGet(baseCard.info);
    if (baseCardToken != null) {
      const tokenStorage: IStorage = {};
      baseCardToken.setInfo(tokenStorage);
      requestInfo['KrCreateBasedOnToken'] = tokenStorage;
    }

    await LoadingOverlay.instance.show(async () => {
      await createCard({
        cardTypeId: model.cardType.id,
        cardTypeName: model.cardType.name,
        info: requestInfo,
        creationModeDisplayText: '$UI_Tiles_CreateCard_Suffix_BasedOn'
      });
    });
  }

  public static async copyARFOWithChangeKc() {
    await CdCardTileExtensionHelper.copyARFOCardAsync(true);
  }

  public static async copyARFOWithoutChangeKc() {
    await CdCardTileExtensionHelper.copyARFOCardAsync(false);
  }

  public static async copyARFOCardAsync(withChangeKcMode: boolean) {
    let uiContext = UIContext.current;
    let editor = uiContext.cardEditor;
    let model;
    if (uiContext == null || editor == null ||
      (model = editor.cardModel) == null ||
      model.card == null) {
      return;
    }

    if (!await showConfirm(withChangeKcMode ? "Создание дубля карточки при обновлении версии Расчета КЦ (с архивацией предыдущей карточки) предполагает внесение новой версии Расчета КЦ (обновление стоимости работ), проверку/корректировку блока РВР перед отправкой карточки на согласование (суммы по видам работ, распределение сумм по виновным). Продложть?" : "Создание дубля карточки для исправления ошибок без изменения версии Расчета КЦ (с архивацией предыдущей карточки) предполагает проверку/корректировку блока РВР перед отправкой карточки на согласование (суммы по видам работ, распределение сумм по виновным) без внесения новой версии Расчета КЦ. Продложть?", "Подтверждение")) {
      return;
    }

    let saveBeforeCreatingCard = false;
    if (model.hasChanges()) {
      const result = await showConfirmWithCancel("$UI_Cards_ConfirmSavingCardBeforeCreatingBasedOn");
      if (result == null) {
        return;
      }
      saveBeforeCreatingCard = result;
    }

    if (saveBeforeCreatingCard) {
      const success = await editor!.saveCard(uiContext);
      if (!success) {
        return;
      }
    }

    const baseCard = editor.cardModel!.card;
    const requestInfo: IStorage = {};
    requestInfo['KrCreateBasedOnCardID'] = createTypedField(baseCard.id, DotNetType.Guid);
    requestInfo['KrCreateBasedOnCopyFiles'] = createTypedField(true, DotNetType.Boolean);
    requestInfo['BasedOn'] = createTypedField(true, DotNetType.Boolean);
    requestInfo['AllowChangeKc'] = createTypedField(withChangeKcMode, DotNetType.Boolean);


    const baseCardToken = KrToken.tryGet(baseCard.info);
    if (baseCardToken != null) {
      const tokenStorage: IStorage = {};
      baseCardToken.setInfo(tokenStorage);
      requestInfo['KrCreateBasedOnToken'] = tokenStorage;
    }

    await LoadingOverlay.instance.show(async () => {
      await createCard({
        cardTypeId: model.cardType.id,
        cardTypeName: model.cardType.name,
        info: requestInfo,
        creationModeDisplayText: '$UI_Tiles_CreateCard_Suffix_BasedOn'
      });
    });

  }

  // public static async downloadCSVReport()
  //       {
  //           let tile = (ITile)parameter;
  //           let viewContext = tile.Context.ViewContext;
  //           if (viewContext == null)
  //               return;

  //           Guid userID = Guid.Empty;

  //           if (tile.Name == "CdDownloadCSVReport")
  //           {
  //               if (viewContext.Data.Any())
  //               {       
  //                   userID = session.User.ID;
  //               }
  //           }

  //           if (userID != Guid.Empty)
  //           {
  //               CardResponse response;
  //               SaveFileDialog saveFileDialog = new SaveFileDialog();
  //               saveFileDialog.Filter = "csv files (*.csv)|*.csv";
  //               saveFileDialog.FilterIndex = 1;
  //               saveFileDialog.RestoreDirectory = true;

  //               if (saveFileDialog.ShowDialog() == DialogResult.OK)
  //               {

  //                   using (TessaSplash.Create("Выгружаются данные"))
  //                   {

  //                       let request = new CardRequest { RequestType = CdRequestTypes.GetCSVReport, Info = { { "UserID", userID } } };
  //                       let response = cardRepository.Request(request);
  //                       TessaDialog.ShowNotEmpty(response.ValidationResult);
  //                   }

  //                   string error = null;
  //                   var fileInf = response.Info.TryGet<string>("Report");
  //                   string completedFile = string.Empty;
  //                   string fileName = string.Empty;

  //                   try
  //                   {
  //                       fileName = saveFileDialog.FileName;
  //                       if (File.Exists(fileName))
  //                       {
  //                           File.Delete(fileName);
  //                       }

  //                       File.WriteAllBytes(fileName, Convert.FromBase64String(fileInf));

  //                       TessaDialog.ShowMessage(string.Format("Файл {0} сохранен", fileName), "Уведомление");
  //                   }
  //                   catch (Exception e)
  //                   {
  //                       error += fileName + Environment.NewLine + e.ToString();
  //                   }

  //                   if (!string.IsNullOrEmpty(error))
  //                   {
  //                       TessaDialog.ShowError($"Произошла ошибка при сохранении файла:{error}");
  //                   }
  //               }
  //           }
  //       }

  public static canDownloadEDRegistry(e: TileEvaluationEventArgs) {
    let visible = false;
    let viewContext = e.currentTile.context.viewContext;
    if (viewContext != null && viewContext.data != null && viewContext.data.length > 0
      && viewContext.view != null && viewContext.workplace != null && viewContext.workplace.currentItem != null) {
      let item = viewContext.workplace.currentItem;
      while (item.parent != null && item.parent.parent != null) {
        if (item.text === "Исполнительная документация") {
          visible = true;
          break;
        }
        item = item.parent;
      }
    }

    e.setIsEnabledWithCollapsing(e.currentTile, visible);
  }

  public static async downloadEDRegistryAction() {

    await showLoadingOverlay(async () => {

      const viewContext = UIContext.current.viewContext;
      if (!viewContext
        || viewContext.view === null
        || viewContext.data === null
      ) {
        return;
      }

      let formattedDate = (moment(new Date())).format('DD-MM-YYYYs HH-mm-ss')
      let fileName = "Реестр ИД (" + formattedDate + ").html";

      // Список ИД всех строк в представлении
      const cardIDs = await CdCardTileExtensionHelper.GetAllViewIdsAsync(viewContext.view, viewContext.parameters);

      if (cardIDs === null || cardIDs.length === 0) {
        return;
      }

      const getFileContentRequest = new CardGetFileContentRequest();
      getFileContentRequest.fileTypeName = CdFileTypes.GetExecutiveDocumentationRegistryFile;

      let info = {
        'cardIDs': cardIDs
      };
      getFileContentRequest.info = info;

      const cardGetFileContentResponse = await CardService.instance.getFileContent(getFileContentRequest);

      if (!cardGetFileContentResponse.validationResult.isSuccessful) {
        throw new Error('Ошибка при получении файла реестра ИД: ' + cardGetFileContentResponse.validationResult.build().toString());
      }

      if (cardGetFileContentResponse.content == null ||
        cardGetFileContentResponse.size === 0) {
        throw new Error('Ошибка при получении файла реестра ИД. Вернулся пустой файл.');
      }

      PkCommonHelper.SaveFileContent(fileName, cardGetFileContentResponse.content);

    }, "Формирование файла \"Реестр ИД\"");
  }

  private static async GetAllViewIdsAsync(view: ITessaView, parameters: IViewParameters): Promise<TypedField<DotNetType, any>[] | null> {
    let viewRequest = new TessaViewRequest(view.metadata);
    viewRequest.calculateRowCounting = false;

    // добавим параметры фильтрации, если они использовались
    if (parameters.parameters.length > 0) {
      parameters.parameters.forEach(e => {
        viewRequest.values.push(e);
      });
    }

    const references: ViewReferenceMetadataSealed[] = [];
    view.metadata.references.forEach(x => references.push(x));
    let entryPrefix = references[0].colPrefix;
    let currentPage = 1;
    let entryIdIndex = -1;
    let pageLimit = 10001;

    const viewPagingParameters = new ViewPagingParameters();
    viewPagingParameters.providePageLimitParameter(viewRequest.values, Paging.Always, pageLimit, false);
    viewPagingParameters.providePageOffsetParameter(viewRequest.values, Paging.Always, currentPage++, pageLimit, false);

    const viewResult = await view.getData(viewRequest);
    if (viewResult.rows.length === 0) {
      return null;
    }

    if (viewResult.rows.length > 10000) {
      await showError("Для исключения зависания программы укажите не более 10000 карточек.");
      return null;
    }

    if (entryIdIndex < 0) {
      entryIdIndex = viewResult.columns.indexOf(entryPrefix + 'ID');

      if (entryIdIndex < 0) {
        return null;
      }
    }

    let docIDs: TypedField[] = new Array;
    for (let rowValue of viewResult.rows) {
      const row = rowValue as any[];
      const id = createTypedField(row[0], DotNetType.Guid);
      docIDs.push(id);
    }

    if (docIDs.length === 0) {
      return null;
    }

    return docIDs;
  }

}